import { Injectable } from '@angular/core';
import { BaseWooCommerceV2ApiService } from './base-woo-commerce-v2-api.service';
import { map, Observable, switchMap } from 'rxjs';
import {
  PostWooCommerceTipBody,
  PostWooCommerceTipResponse,
  WooCommerceTipsResponse
} from '../../../interfaces/woo-commerce/api/tips/tips-api.interface';

@Injectable({ providedIn: 'root' })
export class WooCommerceTipsApiService extends BaseWooCommerceV2ApiService {
  private readonly happyFeesUrl: string = '/cart/fees';
  private readonly happyCartUrl: string = '/cart';

  getTipsOptions(): Observable<WooCommerceTipsResponse> {
    return this.get('/settings/tips').pipe(
      map((response: any) => {
        const data = response?.data || response || {};
        const suggested = data?.suggested_amounts || [10, 15, 20];
        return {
          wc_order_tip_enabled_cart: data?.enabled ? 'yes' : 'no',
          wc_order_tip_cart_position: 'after_total',
          wc_order_tip_enabled_checkout: data?.enabled ? 'yes' : 'no',
          wc_order_tip_checkout_position: 'before_place_order',
          wc_order_tip_is_taxable: 'no',
          wc_order_tip_fee_name: 'Tip',
          wc_order_tip_title: 'Tip',
          wc_order_tip_type: 'percent',
          wc_order_tip_rates: suggested.map((value: number) => String(value)),
          wc_order_tip_custom: data?.custom_allowed ? 'yes' : 'no',
          wc_order_tip_custom_label: 'Custom',
          wc_order_tip_custom_apply_label: 'Apply',
          wc_order_tip_enter_placeholder: 'Enter tip amount',
          wc_order_tip_custom_remove_label: 'Remove',
          wc_order_tip_cash: 'no',
          wc_order_tip_cash_label: '',
          wc_order_tip_remove_new_order: 'yes'
        } as WooCommerceTipsResponse;
      })
    );
  }

  addTipToCart(
    body: PostWooCommerceTipBody
  ): Observable<PostWooCommerceTipResponse> {
    const isPercent = body.tip_type === 'percent';
    const payload = {
      fee_type: 'tip',
      name: 'Tip',
      amount_type: isPercent ? 'percentage' : 'fixed',
      amount_value: isPercent ? body.tip : Math.round(body.tip * 100)
    };

    return this.post(this.happyFeesUrl, payload).pipe(
      map(() => ({
        message: 'Tip applied',
        tip: {
          tip: body.tip,
          tip_type: isPercent ? 1 : 0,
          tip_custom: body.tip_custom,
          tip_cash: 0,
          tip_recurring: false,
          tip_label: 'Tip'
        }
      }))
    );
  }

  removeTipFromCart(): Observable<PostWooCommerceTipResponse> {
    return this.post(this.happyFeesUrl, {
      fee_type: 'tip',
      name: 'Tip',
      amount_type: 'fixed',
      amount_value: 0
    }).pipe(
      switchMap(() => this.get(this.happyCartUrl)),
      map(() => ({
        message: 'Tip removed',
        tip: {
          tip: 0,
          tip_type: 0,
          tip_custom: 0,
          tip_cash: 0,
          tip_recurring: false,
          tip_label: 'Tip'
        }
      }))
    );
  }
}
